import { render } from "./CustomStartupModal.vue?vue&type=template&id=3fc79fa7&scoped=true"
import script from "./CustomStartupModal.vue?vue&type=script&lang=js"
export * from "./CustomStartupModal.vue?vue&type=script&lang=js"

import "./CustomStartupModal.vue?vue&type=style&index=0&id=3fc79fa7&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-deploy-to-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc79fa7"]])

export default __exports__